var _filter, _g, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg01D(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "sun01d",
    cx: "50%",
    cy: "30%",
    r: "70%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#FFE066",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#FF8C42",
      stopOpacity: 1
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "sunShadow01d"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 2,
    dy: 4,
    stdDeviation: 3,
    floodColor: "#FF8C42",
    floodOpacity: 0.3
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#FFE066",
    strokeWidth: 3,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 8,
    x2: 50,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 82,
    x2: 50,
    y2: 92
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 50,
    x2: 18,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 50,
    x2: 92,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.2,
    y1: 21.2,
    x2: 28.3,
    y2: 28.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.7,
    y1: 71.7,
    x2: 78.8,
    y2: 78.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.2,
    y1: 78.8,
    x2: 28.3,
    y2: 71.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.7,
    y1: 28.3,
    x2: 78.8,
    y2: 21.2
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 22,
    fill: "url(#sun01d)",
    filter: "url(#sunShadow01d)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01D);
export default __webpack_public_path__ + "static/media/01d.9e8c9324c560f8dc363fec46e8f8be2f.svg";
export { ForwardRef as ReactComponent };